// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__CWlcm"};